<script>
  import NotificationRowContent from '@app-components/NotificationRowContent.svelte';

  export let notificationClicked;
  export let notification;
  export let user;
  export let mobile;
</script>

<style style="text/scss" lang="scss">
  @import '../vendor/design-system.scss';

  .single-notification {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 24px;
    padding-right: 24px;
    display: flex;
    min-height: 30px;
    &.follow {
      align-items: center;
    }
    &:hover {
      background: #f9f7ff;

      :global(.single-notification-icon) {
        background: white;
      }
    }
  }

  .mobile.single-notification {
    width: 100%;
    min-width: 100%;
    max-width: 100%;

    &:hover {
      background: white;
    }
  }
</style>

{#if notification?.path}
  <a
    href={notification.path}
    class="single-notification {notification.button_style == 'follow_button' ? 'follow' : 'non-follow'}"
    class:mobile={mobile}
    on:click|preventDefault|stopPropagation={notificationClicked(notification, notification.button_style != 'button')}>
    <NotificationRowContent
      notification={notification}
      user={user}
      mobile={mobile}
      notificationClicked={notificationClicked} />
  </a>
{:else}
  <div
    class="single-notification"
    class:mobile={mobile}
    on:click={notificationClicked(notification, notification.button_style != 'button')}>
    <NotificationRowContent
      notification={notification}
      user={user}
      mobile={mobile}
      notificationClicked={notificationClicked} />
  </div>
{/if}
